import React, {PropTypes} from 'react';
import $ from 'jquery';

class Tooltip extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        text: PropTypes.string
    };

    componentDidMount() {
        $(this.refs.tt).tooltip({delay: 50});
    }

    componentWillUnmount() {
        $(this.refs.tt).tooltip('remove');
    }

    render() {
        const {children, text, ...other} = this.props;
        return (
            <div ref="tt" data-position="top" data-tooltip={text} {...other}>
                {children}
            </div>
        );
    }
}

export default Tooltip;